var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "offcanvas-header d-flex justify-content-between align-items-center",
      },
      [
        _vm.userLogged
          ? _c("h3", { staticClass: "offcanvas-title" }, [
              _vm._v(_vm._s(_vm.userName)),
            ])
          : _c("h3", { staticClass: "offcanvas-title" }, [
              _vm._v("Войдите в личный кабинет"),
            ]),
        _vm._v(" "),
        _vm._m(0),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "offcanvas-body" }, [
      _vm.userLogged
        ? _c("div", { staticClass: "offcanvas-body-inner" }, [
            _c("ul", { staticClass: "contact-list list-group-flush" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("li", [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "contact-details" }, [
                  _c(
                    "a",
                    {
                      staticClass: "contact-link",
                      attrs: { href: "#" },
                      on: { click: _vm.logOut },
                    },
                    [_vm._v("\n\t\t\t\t\t\t\tВыйти\n\t\t\t\t\t\t")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "contact-label" }, [
                    _vm._v("Товары в корзине сохранятся"),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "offcanvas-body-inner" }, [_vm._m(3)]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "offcanvas",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("div", { staticClass: "contact-icon" }, [
        _c("i", { staticClass: "mx-auto fa fa-user-secret" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contact-details" }, [
        _c("a", { staticClass: "contact-link", attrs: { href: "/Profile" } }, [
          _vm._v("\n\t\t\t\t\t\t\tПерейти в личный кабинет\n\t\t\t\t\t\t"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "contact-label" }, [
          _vm._v("Там можно посмотреть и редактировать все свои данные"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contact-icon" }, [
      _c("i", { staticClass: "mx-auto fa fa-sign-out" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "contact-list list-group-flush" }, [
      _c("li", [
        _c("div", { staticClass: "contact-icon" }, [
          _c("i", { staticClass: "mx-auto mb-1 fa fa-sign-in" }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "contact-details" }, [
          _c(
            "a",
            {
              staticClass: "contact-link",
              attrs: { href: "/Identity/Account/SignIn" },
            },
            [_vm._v("\n\t\t\t\t\t\t\tВойти / Зерегистрироваться\n\t\t\t\t\t\t")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "contact-label" }, [
            _vm._v(
              "Если вы не помните пароль, восстановить его можно по этой ссылке"
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }